import { GoogleMap, InfoWindow, Marker, withGoogleMap, withScriptjs } from 'react-google-maps';
import React, { Component } from 'react';

import Geocode from 'react-geocode';
import MobileAtmMap from './MobileAtmMap';
import axios from 'axios';

const geocodeJson = 'https://maps.googleapis.com/maps/api/geocode/json';
// AIzaSyBBPIfmZFVCI049D0OK2hFysHqgkxx772c
// AIzaSyCv0JT6W6tMYCww1FnEjf6CxaKUFIhbNdA //With restriction
// Geocode.setApiKey('AIzaSyC2FbFd6rCGV3OMfs-nErJXjN2mc5EDWsU'); //With out restriction
Geocode.setApiKey('AIzaSyCa3IAH1rlFQ8rKB9CdIciAZSUfMq3g0EY'); //With out restriction new
Geocode.enableDebug();
class MobileAtmFunctional extends Component {
	constructor(props) {
		super(props);
		this.state = {
			address: '',
			city: '',
			area: '',
			state: '',
			lmg: '',
			rmg: '',
			mapPosition: {
				lat: 13.0827,
				lng: 80.2707,
			},
			markerPosition: {
				lat: 0,
				lng: 0,
			},
			atmLocationData: [],
			isLoading: false,
		};
		this.getMyLocation = this.getMyLocation.bind(this);
	}

	componentDidMount() {
		Geocode.fromLatLng(this.state.mapPosition.lat, this.state.mapPosition.lng).then(
			(response) => {
				const address = response.results[0].formatted_address,
					addressArray = response.results[0].address_components,
					city = this.getCity(addressArray),
					area = this.getArea(addressArray),
					state = this.getState(addressArray);
				this.setState({
					address: address ? address : '',
					area: area ? area : '',
					city: city ? city : '',
					state: state ? state : '',
				});
			},
			(error) => {
				console.error(error);
			}
		);
	}
	componentWillReceiveProps(nextProps) {
		// You don't have to do this check first, but it can help prevent an unneeded render
		if (nextProps.center !== this.state.mapPosition) {
			this.setState({ mapPosition: nextProps.center });
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (
			this.state.markerPosition.lat !== this.props.center.lat ||
			this.state.address !== nextState.address ||
			this.state.city !== nextState.city ||
			this.state.area !== nextState.area ||
			this.state.state !== nextState.state
		) {
			return true;
		} else if (this.props.center.lat === nextProps.center.lat) {
			return false;
		}
	}

	getCity = (addressArray) => {
		let city = '';
		for (let i = 0; i < addressArray.length; i++) {
			if (addressArray[i].types[0] && 'administrative_area_level_2' === addressArray[i].types[0]) {
				city = addressArray[i].long_name;
				return city;
			}
		}
	};

	getArea = (addressArray) => {
		let area = '';
		for (let i = 0; i < addressArray.length; i++) {
			if (addressArray[i].types[0]) {
				for (let j = 0; j < addressArray[i].types.length; j++) {
					if ('sublocality_level_1' === addressArray[i].types[j] || 'locality' === addressArray[i].types[j]) {
						area = addressArray[i].long_name;
						return area;
					}
				}
			}
		}
	};

	getLandmark = (addressArray) => {
		let area = '';
		for (let i = 0; i < addressArray.length; i++) {
			if (addressArray[i].types[0]) {
				for (let j = 0; j < addressArray[i].types.length; j++) {
					if ('sublocality_level_1' === addressArray[i].types[j] || 'landmark' === addressArray[i].types[j]) {
						area = addressArray[i].long_name;
						return area;
					}
				}
			}
		}
	};

	getState = (addressArray) => {
		let state = '';
		for (let i = 0; i < addressArray.length; i++) {
			for (let i = 0; i < addressArray.length; i++) {
				if (addressArray[i].types[0] && 'administrative_area_level_1' === addressArray[i].types[0]) {
					state = addressArray[i].long_name;
					return state;
				}
			}
		}
	};

	onChange = (event) => {
		this.setState({ [event.target.name]: event.target.value });
	};

	onInfoWindowClose = (event) => {};

	onMarkerDragEnd = (event) => {
		let newLat = event.latLng.lat(),
			newLng = event.latLng.lng();

		Geocode.fromLatLng(newLat, newLng).then(
			(response) => {
				const address = response.results[0].formatted_address,
					addressArray = response.results[0].address_components,
					city = this.getCity(addressArray),
					area = this.getArea(addressArray),
					state = this.getState(addressArray);
				this.setState({
					address: address ? address : '',
					area: area ? area : '',
					city: city ? city : '',
					state: state ? state : '',
					markerPosition: {
						lat: newLat,
						lng: newLng,
					},
					// mapPosition: {
					// 	lat: newLat,
					// 	lng: newLng,
					// },
				});
			},
			(error) => {
				console.error(error);
			}
		);
	};
	onPlaceSelected = (place) => {
		try {
			let phoneNumber = place.formatted_phone_number;
			let name = place.name;
			let address = place.formatted_address,
				addressArray = place.address_components,
				city = this.getCity(addressArray),
				area = this.getArea(addressArray),
				state = this.getState(addressArray),
				latValue = place.geometry.location.lat(),
				lngValue = place.geometry.location.lng();

			let landmark = this.getLandmark(addressArray);

			// Set these values in the state.

			this.setState({
				address: address ? address : '',
				area: area ? area : '',
				city: city ? city : '',
				state: state ? state : '',
				markerPosition: {
					lat: latValue,
					lng: lngValue,
				},
				mapPosition: {
					lat: latValue,
					lng: lngValue,
				},
			});
			this.props.setValuesForAddressForm({ area, phoneNumber, name });
		} catch (error) {
			console.log(error);
		}
	};

	reverseGeocode = ({ latitude: lat, longitude: lng }) => {
		const url = `${geocodeJson}?key=AIzaSyCv0JT6W6tMYCww1FnEjf6CxaKUFIhbNdA&latlng=${lat},${lng}`;
		fetch(url)
			.then((response) => response.json())
			.then((location) => {
				// const place = location.results[0];
				// const _address = extractAddress(place);
				// setAddress(_address);
				// searchInput.current.value = _address.plain();
			});
	};
	async getMyLocation() {
		Geocode.setLocationType('ROOFTOP');
		let lat = null;
		let lng = null;
		const location = window.navigator && window.navigator.geolocation;
		if (location) {
			location.getCurrentPosition(
				(position) => {
					lat = position.coords.latitude;
					lat = position.coords.longitude;
					this.reverseGeocode(position.coords);
					// Geocode.fromLatLng(position.coords.latitude, position.coords.longitude)
					// 	.then((res) => {
					// 		console.log('re33324', res);
					// 	})
					// 	.catch((error) => {
					// 		console.log('geoerror', error);
					// 	});
					this.setState({
						mapPosition: {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
						},
						markerPosition: {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
						},
					});
				},
				(error) => {
					console.log(error);
					this.setState({ latitude: 'err-latitude', longitude: 'err-longitude' });
				}
			);
		}
	}

	render() {
		return (
			<MobileAtmMap
				setEnableLocationPromt={this.props.setEnableLocationPromt}
				onPlaceSelected={this.onPlaceSelected}
				atmCoordinates={this.props.atmCoordinates}
				onMarkerDragEnd={this.onMarkerDragEnd}
				onChange={this.onChange}
				getCity={this.getCity}
				getArea={this.getArea}
				getState={this.getState}
				lat={this.props.center.lat}
				lng={this.props.center.lng}
				getMyLocation={this.getMyLocation}
				mapPosition={this.state.mapPosition}
				markerPosition={this.state.mapPosition}
				address={this.state.address}
				google={this.props.google}
				zoom={this.props.zoom}
				height={this.props.height}
				mylocation={this.props.mylocation}
				search={this.props.search}
				c3atmsIsSelected={this.props.atmsC}
				rakatmIsSelected={this.props.rakbankAtm}
				atmlocationData={this.props.atmlocationData}
				markerOff={this.props.markerOff}
				allEmirates={this.props.allEmirates}
				selectedEmirate={this.props.selectedEmirate}
				locationList={this.props.locationList}
				infoData={this.props.infoData}
				defaultSwitch={this.props.defaultSwitch}
				nodata={this.props.nodata}
				EnableLocation={this.props.EnableLocation}
			/>
		);
	}
}
export default MobileAtmFunctional;
